


































































































































import { Component, Vue,Inject,Prop,Emit } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
@Component({})
export default class SidebarMenu extends AbpBase {
    $route: any
    name:string='sidebarMenu';
    userPer: boolean = false;
    rolePer: boolean = false;
    mode: string = 'vertical';
    @Prop({type:Array}) menuList:Array<any>;
    @Prop({type:Number}) iconSize:number;
    @Prop({type:String,default:'dark'}) menuTheme:string;
    @Prop({type:Array}) openNames:Array<string>;
    openMenuNames: Array<string> = this.openNames;
    itemTitle(item:any):string{
        return this.L(item.meta.title);
    }
    @Emit('on-change')
    changeMenu(active:string){
    }
    get activeName(){
        return this.$route.meta.activeName?this.$route.meta.activeName:this.$route.name;
        // return this.$route.name;
    }
    updated () {
        this.$nextTick(() => {
            if (this.$refs.sideMenu) {
                (this.$refs.sideMenu as any).updateActiveName();
            }
        });
    }
    isThirdLevelMenu(child:any){
        if(child.children && child.children.length > 0){
            return true;
        }else{
            return false;
        }
    }
    async GetPer() {
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.userPer = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.Users'] == 'true' ? true : false;
        this.rolePer = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.Roles'] == 'true' ? true : false;
    }
    mounted() {
        this.GetPer();
        if(localStorage.getItem('autoBool') == '1'){
            this.mode = 'horizontal';
        }
        this.$nextTick( () => {
            if(localStorage.getItem('autoBool') != '1'){
                (this.$refs.sideMenu as any).updateOpened();
            }
            (this.$refs.sideMenu as any).updateActiveName()
        } )
    }
}
